export const genInfoTranslations = {
  en: {
    title: "🌍 The Future Belongs to Gen Z & Gen Alpha",
    subtitle:
      "Together they represent nearly half of humanity and will define the AI era.",

    generation: "Generation",
    birthYears: "Birth Years",
    population: "Population",
    share: "Share",

    indiaSnapshot: "🇮🇳 India Generation Snapshot",
    indiaYouthAdvantage: "🇮🇳 India's Youth Advantage",

    indiaPoint1: "🌍 India has massive Gen Z + Gen Alpha population.",
    indiaPoint2: "📱 Mobile-first + AI-native ecosystem.",
    indiaPoint3: "🚀 Built for execution + opportunity creation.",

    alphaTitle: "⚡ Generation Alpha",
    alphaDesc:
      "AI-native, fully digital-first generation growing with automation, gaming, and intelligent systems.",

    genzTitle: "🚀 Generation Z",
    genzDesc:
      "Creator economy, startup mindset, digital workforce leaders.",

    whyTitle: "🧠 Why This Matters",
    whyDesc:
      "Built for Gen Z and Gen Alpha to transform learning into execution, skills into opportunities, and ideas into real-world outcomes."
  },

  hi: {
    title: "🌍 भविष्य Gen Z और Gen Alpha का है",
    subtitle:
      "मिलकर ये मानवता के लगभग आधे हिस्से का प्रतिनिधित्व करते हैं और AI युग को आकार देंगे।",

    generation: "पीढ़ी",
    birthYears: "जन्म वर्ष",
    population: "जनसंख्या",
    share: "हिस्सा",

    indiaSnapshot: "🇮🇳 भारत पीढ़ी अवलोकन",
    indiaYouthAdvantage: "🇮🇳 भारत की युवा शक्ति",

    indiaPoint1: "🌍 भारत में Gen Z और Gen Alpha की विशाल आबादी है।",
    indiaPoint2: "📱 मोबाइल-प्रथम और AI-आधारित पारिस्थितिकी तंत्र।",
    indiaPoint3: "🚀 अवसर निर्माण और क्रियान्वयन के लिए तैयार।",

    alphaTitle: "⚡ जनरेशन अल्फा",
    alphaDesc:
      "AI और डिजिटल तकनीकों के साथ बढ़ने वाली नई पीढ़ी।",

    genzTitle: "🚀 जनरेशन Z",
    genzDesc:
      "क्रिएटर इकॉनमी, स्टार्टअप सोच और डिजिटल नेतृत्व वाली पीढ़ी।",

    whyTitle: "🧠 यह क्यों महत्वपूर्ण है",
    whyDesc:
      "सीखने को क्रियान्वयन में, कौशल को अवसरों में और विचारों को वास्तविक परिणामों में बदलने के लिए।"
  },
  bn: {
    title: "🌍 ভবিষ্যৎ Gen Z এবং Gen Alpha-এর",
    subtitle:
      "তারা একসাথে মানবজাতির প্রায় অর্ধেককে প্রতিনিধিত্ব করে এবং AI যুগকে সংজ্ঞায়িত করবে।",

    generation: "প্রজন্ম",
    birthYears: "জন্ম সাল",
    population: "জনসংখ্যা",
    share: "অংশ",

    indiaSnapshot: "🇮🇳 ভারতের প্রজন্মের চিত্র",
    indiaYouthAdvantage: "🇮🇳 ভারতের যুব শক্তি",

    indiaPoint1: "🌍 ভারতে Gen Z এবং Gen Alpha-এর বিশাল জনসংখ্যা রয়েছে।",
    indiaPoint2: "📱 মোবাইল-প্রথম এবং AI-নেটিভ ইকোসিস্টেম।",
    indiaPoint3: "🚀 বাস্তবায়ন ও সুযোগ সৃষ্টির জন্য প্রস্তুত।",

    alphaTitle: "⚡ জেনারেশন আলফা",
    alphaDesc:
      "AI-নেটিভ, সম্পূর্ণ ডিজিটাল-প্রথম প্রজন্ম যারা অটোমেশন, গেমিং এবং বুদ্ধিমান প্রযুক্তির সাথে বেড়ে উঠছে।",

    genzTitle: "🚀 জেনারেশন Z",
    genzDesc:
      "ক্রিয়েটর ইকোনমি, স্টার্টআপ মানসিকতা এবং ডিজিটাল কর্মশক্তির নেতৃত্বদানকারী প্রজন্ম।",

    whyTitle: "🧠 কেন এটি গুরুত্বপূর্ণ",
    whyDesc:
      "Gen Z এবং Gen Alpha-কে শেখাকে বাস্তবায়নে, দক্ষতাকে সুযোগে এবং ধারণাকে বাস্তব ফলাফলে রূপান্তর করতে সক্ষম করার জন্য।"
  },

  mr: {
    title: "🌍 भविष्य Gen Z आणि Gen Alpha चे आहे",
    subtitle:
      "एकत्रितपणे ते मानवजातीच्या जवळपास अर्ध्या लोकसंख्येचे प्रतिनिधित्व करतात आणि AI युगाची दिशा ठरवतील.",

    generation: "पिढी",
    birthYears: "जन्म वर्षे",
    population: "लोकसंख्या",
    share: "वाटा",

    indiaSnapshot: "🇮🇳 भारतातील पिढ्यांचे चित्र",
    indiaYouthAdvantage: "🇮🇳 भारताची युवा शक्ती",

    indiaPoint1: "🌍 भारतात Gen Z आणि Gen Alpha ची प्रचंड लोकसंख्या आहे.",
    indiaPoint2: "📱 मोबाईल-फर्स्ट आणि AI-नेटिव्ह परिसंस्था.",
    indiaPoint3: "🚀 अंमलबजावणी आणि संधी निर्मितीसाठी सज्ज.",

    alphaTitle: "⚡ जनरेशन अल्फा",
    alphaDesc:
      "AI-नेटिव्ह, पूर्णपणे डिजिटल-फर्स्ट पिढी जी ऑटोमेशन, गेमिंग आणि बुद्धिमान प्रणालींसह वाढत आहे.",

    genzTitle: "🚀 जनरेशन Z",
    genzDesc:
      "क्रिएटर इकॉनॉमी, स्टार्टअप मानसिकता आणि डिजिटल कार्यबलाचे नेतृत्व करणारी पिढी.",

    whyTitle: "🧠 हे महत्त्वाचे का आहे",
    whyDesc:
      "Gen Z आणि Gen Alpha यांना शिक्षणाचे कृतीत, कौशल्यांचे संधींमध्ये आणि कल्पनांचे वास्तविक परिणामांमध्ये रूपांतर करण्यासाठी सक्षम बनवणे."
  },

  gu: {
    title: "🌍 ભવિષ્ય Gen Z અને Gen Alpha નું છે",
    subtitle:
      "મળીને તેઓ માનવજાતિના લગભગ અડધા હિસ્સાનું પ્રતિનિધિત્વ કરે છે અને AI યુગને આકાર આપશે.",

    generation: "પેઢી",
    birthYears: "જન્મ વર્ષો",
    population: "વસ્તી",
    share: "હિસ્સો",

    indiaSnapshot: "🇮🇳 ભારતની પેઢીઓનું ચિત્ર",
    indiaYouthAdvantage: "🇮🇳 ભારતની યુવા શક્તિ",

    indiaPoint1: "🌍 ભારતમાં Gen Z અને Gen Alpha ની વિશાળ વસ્તી છે.",
    indiaPoint2: "📱 મોબાઇલ-ફર્સ્ટ અને AI-નેટિવ ઇકોસિસ્ટમ.",
    indiaPoint3: "🚀 અમલીકરણ અને તકોના સર્જન માટે તૈયાર.",

    alphaTitle: "⚡ જનરેશન અલ્ફા",
    alphaDesc:
      "AI-નેટિવ, સંપૂર્ણ ડિજિટલ-ફર્સ્ટ પેઢી જે ઓટોમેશન, ગેમિંગ અને બુદ્ધિશાળી સિસ્ટમ્સ સાથે વિકસી રહી છે.",

    genzTitle: "🚀 જનરેશન Z",
    genzDesc:
      "ક્રિએટર ઇકોનોમી, સ્ટાર્ટઅપ માનસિકતા અને ડિજિટલ વર્કફોર્સનું નેતૃત્વ કરતી પેઢી.",

    whyTitle: "🧠 આ શા માટે મહત્વનું છે",
    whyDesc:
      "Gen Z અને Gen Alpha ને શીખવાનું અમલીકરણમાં, કુશળતાઓને તકોમાં અને વિચારોને વાસ્તવિક પરિણામોમાં પરિવર્તિત કરવામાં સક્ષમ બનાવવા માટે."
  },

  ta: {
    title: "🌍 எதிர்காலம் Gen Z மற்றும் Gen Alpha தலைமுறைகளுக்கே சொந்தமானது",
    subtitle:
      "இருவரும் சேர்ந்து மனிதகுலத்தின் பாதிக்கு நெருக்கமான பகுதியை பிரதிநிதித்துவப்படுத்துகின்றனர் மற்றும் AI காலத்தை வடிவமைப்பார்கள்.",

    generation: "தலைமுறை",
    birthYears: "பிறந்த ஆண்டுகள்",
    population: "மக்கள் தொகை",
    share: "பங்கு",

    indiaSnapshot: "🇮🇳 இந்திய தலைமுறை கண்ணோட்டம்",
    indiaYouthAdvantage: "🇮🇳 இந்தியாவின் இளையோர் வலிமை",

    indiaPoint1: "🌍 இந்தியாவில் Gen Z மற்றும் Gen Alpha தலைமுறைகளின் மிகப்பெரிய மக்கள் தொகை உள்ளது.",
    indiaPoint2: "📱 மொபைல்-முதல் மற்றும் AI-நேட்டிவ் சூழல்.",
    indiaPoint3: "🚀 செயல்படுத்தல் மற்றும் வாய்ப்புகளை உருவாக்க தயாராக உள்ளது.",

    alphaTitle: "⚡ ஜெனரேஷன் அல்பா",
    alphaDesc:
      "AI-நேட்டிவ், முழுமையாக டிஜிட்டல்-முதல் தலைமுறை; தானியக்கம், விளையாட்டு மற்றும் புத்திசாலி தொழில்நுட்பங்களுடன் வளர்கிறது.",

    genzTitle: "🚀 ஜெனரேஷன் Z",
    genzDesc:
      "கிரியேட்டர் பொருளாதாரம், ஸ்டார்ட்அப் மனப்பாங்கு மற்றும் டிஜிட்டல் பணியாளர்களின் தலைமை தலைமுறை.",

    whyTitle: "🧠 இது ஏன் முக்கியம்",
    whyDesc:
      "Gen Z மற்றும் Gen Alpha தலைமுறைகள் கற்றலை செயலாக்கமாகவும், திறன்களை வாய்ப்புகளாகவும், யோசனைகளை நிஜ உலக முடிவுகளாகவும் மாற்ற உதவுவதற்காக."
  },
  te: {
    title: "🌍 భవిష్యత్తు Gen Z మరియు Gen Alpha తరాలదే",
    subtitle:
      "వీరు కలిసి మానవాళిలో సగానికి సమీపమైన జనాభాను ప్రతినిధ్యం వహిస్తూ AI యుగాన్ని నిర్వచించనున్నారు.",

    generation: "తరం",
    birthYears: "పుట్టిన సంవత్సరాలు",
    population: "జనాభా",
    share: "వాటా",

    indiaSnapshot: "🇮🇳 భారత తరం దృశ్యం",
    indiaYouthAdvantage: "🇮🇳 భారత యువ శక్తి",

    indiaPoint1: "🌍 భారతదేశంలో Gen Z మరియు Gen Alpha యొక్క భారీ జనాభా ఉంది.",
    indiaPoint2: "📱 మొబైల్-ఫస్ట్ మరియు AI-నేటివ్ వ్యవస్థ.",
    indiaPoint3: "🚀 అమలు మరియు అవకాశాల సృష్టికి సిద్ధంగా ఉంది.",

    alphaTitle: "⚡ జనరేషన్ అల్ఫా",
    alphaDesc:
      "AI-నేటివ్, పూర్తిగా డిజిటల్-ఫస్ట్ తరం; ఆటోమేషన్, గేమింగ్ మరియు స్మార్ట్ టెక్నాలజీలతో పెరుగుతోంది.",

    genzTitle: "🚀 జనరేషన్ Z",
    genzDesc:
      "క్రియేటర్ ఎకానమీ, స్టార్టప్ ఆలోచనా విధానం మరియు డిజిటల్ వర్క్‌ఫోర్స్ నాయకత్వ తరం.",

    whyTitle: "🧠 ఇది ఎందుకు ముఖ్యమైనది",
    whyDesc:
      "Gen Z మరియు Gen Alpha తరాలు నేర్చుకోవడాన్ని కార్యరూపంలోకి, నైపుణ్యాలను అవకాశాలుగా, ఆలోచనలను వాస్తవ ఫలితాలుగా మార్చేందుకు నిర్మించబడింది."
  },

  kn: {
    title: "🌍 ಭವಿಷ್ಯವು Gen Z ಮತ್ತು Gen Alpha ತಲೆಮಾರುಗಳದು",
    subtitle:
      "ಇವರು ಒಟ್ಟಾಗಿ ಮಾನವಕುಲದ ಸುಮಾರು ಅರ್ಧ ಭಾಗವನ್ನು ಪ್ರತಿನಿಧಿಸುತ್ತಾರೆ ಮತ್ತು AI ಯುಗವನ್ನು ರೂಪಿಸಲಿದ್ದಾರೆ.",

    generation: "ತಲೆಮಾರು",
    birthYears: "ಜನನ ವರ್ಷಗಳು",
    population: "ಜನಸಂಖ್ಯೆ",
    share: "ಪಾಲು",

    indiaSnapshot: "🇮🇳 ಭಾರತದ ತಲೆಮಾರುಗಳ ಚಿತ್ರಣ",
    indiaYouthAdvantage: "🇮🇳 ಭಾರತದ ಯುವ ಶಕ್ತಿ",

    indiaPoint1: "🌍 ಭಾರತದಲ್ಲಿ Gen Z ಮತ್ತು Gen Alpha ಯ ಭಾರೀ ಜನಸಂಖ್ಯೆ ಇದೆ.",
    indiaPoint2: "📱 ಮೊಬೈಲ್-ಮೊದಲ ಮತ್ತು AI-ನೇಟಿವ್ ಪರಿಸರ ವ್ಯವಸ್ಥೆ.",
    indiaPoint3: "🚀 ಕಾರ್ಯಗತಗೊಳಿಸುವಿಕೆ ಮತ್ತು ಅವಕಾಶ ಸೃಷ್ಟಿಗಾಗಿ ಸಿದ್ಧವಾಗಿದೆ.",

    alphaTitle: "⚡ ಜನರೇಷನ್ ಅಲ್ಫಾ",
    alphaDesc:
      "AI-ನೇಟಿವ್, ಸಂಪೂರ್ಣ ಡಿಜಿಟಲ್-ಮೊದಲ ತಲೆಮಾರು; ಸ್ವಯಂಚಾಲಿತ ವ್ಯವಸ್ಥೆಗಳು, ಗೇಮಿಂಗ್ ಮತ್ತು ಬುದ್ಧಿವಂತ ತಂತ್ರಜ್ಞಾನಗಳೊಂದಿಗೆ ಬೆಳೆಯುತ್ತಿದೆ.",

    genzTitle: "🚀 ಜನರೇಷನ್ Z",
    genzDesc:
      "ಕ್ರಿಯೇಟರ್ ಆರ್ಥಿಕತೆ, ಸ್ಟಾರ್ಟಪ್ ಮನೋಭಾವ ಮತ್ತು ಡಿಜಿಟಲ್ ಕಾರ್ಯಪಡೆಯ ನಾಯಕತ್ವ ತಲೆಮಾರು.",

    whyTitle: "🧠 ಇದು ಏಕೆ ಮಹತ್ವದ್ದಾಗಿದೆ",
    whyDesc:
      "Gen Z ಮತ್ತು Gen Alpha ತಲೆಮಾರುಗಳು ಕಲಿಕೆಯನ್ನು ಕಾರ್ಯಗತಗೊಳಿಸುವಿಕೆಗೆ, ಕೌಶಲ್ಯಗಳನ್ನು ಅವಕಾಶಗಳಿಗೆ ಮತ್ತು ಆಲೋಚನೆಗಳನ್ನು ನೈಜ ಫಲಿತಾಂಶಗಳಿಗೆ ಪರಿವರ್ತಿಸಲು ನಿರ್ಮಿಸಲಾಗಿದೆ."
  },

  ml: {
    title: "🌍 ഭാവി Gen Z യുടെയും Gen Alpha യുടെയുംതാണ്",
    subtitle:
      "ഇവർ ഒരുമിച്ച് മനുഷ്യരാശിയുടെ പകുതിയോട് അടുത്ത ജനസംഖ്യയെ പ്രതിനിധീകരിക്കുകയും AI യുഗത്തെ നിർവചിക്കുകയും ചെയ്യും.",

    generation: "തലമുറ",
    birthYears: "ജനന വർഷങ്ങൾ",
    population: "ജനസംഖ്യ",
    share: "വിഹിതം",

    indiaSnapshot: "🇮🇳 ഇന്ത്യയുടെ തലമുറകളുടെ ചിത്രം",
    indiaYouthAdvantage: "🇮🇳 ഇന്ത്യയുടെ യുവശക്തി",

    indiaPoint1: "🌍 ഇന്ത്യയിൽ Gen Z, Gen Alpha തലമുറകളുടെ വൻ ജനസംഖ്യയുണ്ട്.",
    indiaPoint2: "📱 മൊബൈൽ-ഫസ്റ്റ്, AI-നേറ്റീവ് പരിസ്ഥിതി.",
    indiaPoint3: "🚀 നടപ്പാക്കലിനും അവസര സൃഷ്ടിക്കും തയ്യാറാണ്.",

    alphaTitle: "⚡ ജനറേഷൻ അൽഫ",
    alphaDesc:
      "AI-നേറ്റീവ്, പൂർണ്ണമായും ഡിജിറ്റൽ-ഫസ്റ്റ് തലമുറ; ഓട്ടോമേഷൻ, ഗെയിമിംഗ്, ബുദ്ധിമാനായ സാങ്കേതികവിദ്യകൾക്കൊപ്പം വളരുന്നു.",

    genzTitle: "🚀 ജനറേഷൻ Z",
    genzDesc:
      "ക്രിയേറ്റർ ഇക്കോണമി, സ്റ്റാർട്ടപ്പ് മനോഭാവം, ഡിജിറ്റൽ തൊഴിലാളി നേതൃപാടവം എന്നിവയുടെ തലമുറ.",

    whyTitle: "🧠 ഇത് എന്തുകൊണ്ട് പ്രധാനമാണ്",
    whyDesc:
      "Gen Z, Gen Alpha തലമുറകൾക്ക് പഠനത്തെ പ്രവർത്തനമാക്കാനും, കഴിവുകളെ അവസരങ്ങളാക്കാനും, ആശയങ്ങളെ യഥാർത്ഥ ഫലങ്ങളാക്കാനും സഹായിക്കുന്നതിനായാണ് ഇത് നിർമ്മിച്ചിരിക്കുന്നത്."
  },

  pa: {
    title: "🌍 ਭਵਿੱਖ Gen Z ਅਤੇ Gen Alpha ਦਾ ਹੈ",
    subtitle:
      "ਇਹ ਇਕੱਠੇ ਮਨੁੱਖਤਾ ਦੇ ਲਗਭਗ ਅੱਧੇ ਹਿੱਸੇ ਦੀ ਨੁਮਾਇੰਦਗੀ ਕਰਦੇ ਹਨ ਅਤੇ AI ਯੁੱਗ ਨੂੰ ਪਰਿਭਾਸ਼ਿਤ ਕਰਨਗੇ।",

    generation: "ਪੀੜ੍ਹੀ",
    birthYears: "ਜਨਮ ਸਾਲ",
    population: "ਆਬਾਦੀ",
    share: "ਹਿੱਸਾ",

    indiaSnapshot: "🇮🇳 ਭਾਰਤ ਦੀ ਪੀੜ੍ਹੀ ਝਲਕ",
    indiaYouthAdvantage: "🇮🇳 ਭਾਰਤ ਦੀ ਨੌਜਵਾਨ ਤਾਕਤ",

    indiaPoint1: "🌍 ਭਾਰਤ ਵਿੱਚ Gen Z ਅਤੇ Gen Alpha ਦੀ ਬਹੁਤ ਵੱਡੀ ਆਬਾਦੀ ਹੈ।",
    indiaPoint2: "📱 ਮੋਬਾਈਲ-ਪਹਿਲਾਂ ਅਤੇ AI-ਨੇਟਿਵ ਇਕੋਸਿਸਟਮ।",
    indiaPoint3: "🚀 ਕਾਰਜਾਨਵਿਨ ਅਤੇ ਮੌਕਿਆਂ ਦੀ ਸਿਰਜਣਾ ਲਈ ਤਿਆਰ।",

    alphaTitle: "⚡ ਜਨਰੇਸ਼ਨ ਅਲਫਾ",
    alphaDesc:
      "AI-ਨੇਟਿਵ, ਪੂਰੀ ਤਰ੍ਹਾਂ ਡਿਜ਼ਿਟਲ-ਪਹਿਲਾਂ ਪੀੜ੍ਹੀ ਜੋ ਆਟੋਮੇਸ਼ਨ, ਗੇਮਿੰਗ ਅਤੇ ਸਮਾਰਟ ਤਕਨਾਲੋਜੀਆਂ ਨਾਲ ਵਧ ਰਹੀ ਹੈ।",

    genzTitle: "🚀 ਜਨਰੇਸ਼ਨ Z",
    genzDesc:
      "ਕ੍ਰੀਏਟਰ ਅਰਥਵਿਵਸਥਾ, ਸਟਾਰਟਅਪ ਸੋਚ ਅਤੇ ਡਿਜ਼ਿਟਲ ਵਰਕਫੋਰਸ ਦੀ ਅਗਵਾਈ ਕਰਨ ਵਾਲੀ ਪੀੜ੍ਹੀ।",

    whyTitle: "🧠 ਇਹ ਕਿਉਂ ਮਹੱਤਵਪੂਰਨ ਹੈ",
    whyDesc:
      "Gen Z ਅਤੇ Gen Alpha ਨੂੰ ਸਿੱਖਣ ਨੂੰ ਕਾਰਵਾਈ ਵਿੱਚ, ਹੁਨਰਾਂ ਨੂੰ ਮੌਕਿਆਂ ਵਿੱਚ ਅਤੇ ਵਿਚਾਰਾਂ ਨੂੰ ਅਸਲ ਨਤੀਜਿਆਂ ਵਿੱਚ ਬਦਲਣ ਲਈ ਤਿਆਰ ਕੀਤਾ ਗਿਆ ਹੈ।"
  },
  as: {
    title: "🌍 ভৱিষ্যৎ Gen Z আৰু Gen Alpha ৰ",
    subtitle:
      "তেওঁলোকে একেলগে মানৱজাতিৰ প্ৰায় আধা অংশক প্ৰতিনিধিত্ব কৰে আৰু AI যুগক সংজ্ঞায়িত কৰিব।",

    generation: "প্ৰজন্ম",
    birthYears: "জন্ম বৰ্ষ",
    population: "জনসংখ্যা",
    share: "অংশ",

    indiaSnapshot: "🇮🇳 ভাৰতৰ প্ৰজন্মৰ চিত্ৰ",
    indiaYouthAdvantage: "🇮🇳 ভাৰতৰ যুৱ শক্তি",

    indiaPoint1: "🌍 ভাৰতত Gen Z আৰু Gen Alpha ৰ বিশাল জনসংখ্যা আছে।",
    indiaPoint2: "📱 মোবাইল-প্ৰথম আৰু AI-নেটিভ পৰিবেশ।",
    indiaPoint3: "🚀 কাৰ্যকৰী ৰূপায়ণ আৰু সুযোগ সৃষ্টিৰ বাবে সাজু।",

    alphaTitle: "⚡ জেনেৰেচন আলফা",
    alphaDesc:
      "AI-নেটিভ, সম্পূৰ্ণ ডিজিটেল-প্ৰথম প্ৰজন্ম যি অটোমেচন, গেমিং আৰু বুদ্ধিমান প্ৰযুক্তিৰ সৈতে ডাঙৰ হৈছে।",

    genzTitle: "🚀 জেনেৰেচন Z",
    genzDesc:
      "সৃষ্টিকৰ্তা অৰ্থনীতি, ষ্টাৰ্টআপ মনোভাৱ আৰু ডিজিটেল কৰ্মশক্তিৰ নেতৃত্বদানকাৰী প্ৰজন্ম।",

    whyTitle: "🧠 এইটো কিয় গুৰুত্বপূৰ্ণ",
    whyDesc:
      "Gen Z আৰু Gen Alpha ক শিক্ষা কাৰ্যত, দক্ষতা সুযোগত আৰু ধাৰণাক বাস্তৱ ফলাফলত ৰূপান্তৰিত কৰিবলৈ গঢ়া হৈছে।"
  },

  ur: {
    title: "🌍 مستقبل Gen Z اور Gen Alpha کا ہے",
    subtitle:
      "یہ دونوں مل کر انسانیت کے تقریباً نصف حصے کی نمائندگی کرتے ہیں اور AI دور کی تشکیل کریں گے۔",

    generation: "نسل",
    birthYears: "پیدائش کے سال",
    population: "آبادی",
    share: "حصہ",

    indiaSnapshot: "🇮🇳 بھارت کی نسلی جھلک",
    indiaYouthAdvantage: "🇮🇳 بھارت کی نوجوان طاقت",

    indiaPoint1: "🌍 بھارت میں Gen Z اور Gen Alpha کی بہت بڑی آبادی موجود ہے۔",
    indiaPoint2: "📱 موبائل فرسٹ اور AI-نیٹو ماحولیاتی نظام۔",
    indiaPoint3: "🚀 عمل درآمد اور مواقع پیدا کرنے کے لیے تیار۔",

    alphaTitle: "⚡ جنریشن الفا",
    alphaDesc:
      "AI-نیٹو، مکمل طور پر ڈیجیٹل فرسٹ نسل جو آٹومیشن، گیمنگ اور ذہین ٹیکنالوجی کے ساتھ پروان چڑھ رہی ہے۔",

    genzTitle: "🚀 جنریشن Z",
    genzDesc:
      "کریئیٹر اکانومی، اسٹارٹ اپ ذہنیت اور ڈیجیٹل ورک فورس کی قیادت کرنے والی نسل۔",

    whyTitle: "🧠 یہ کیوں اہم ہے",
    whyDesc:
      "Gen Z اور Gen Alpha کو سیکھنے کو عمل میں، مہارتوں کو مواقع میں اور خیالات کو حقیقی نتائج میں تبدیل کرنے کے لیے بنایا گیا ہے۔"
  },

  ar: {
    title: "🌍 المستقبل ينتمي إلى Gen Z و Gen Alpha",
    subtitle:
      "يمثلون معًا ما يقارب نصف البشرية وسيشكلون عصر الذكاء الاصطناعي.",

    generation: "الجيل",
    birthYears: "سنوات الميلاد",
    population: "عدد السكان",
    share: "النسبة",

    indiaSnapshot: "🇮🇳 نظرة على أجيال الهند",
    indiaYouthAdvantage: "🇮🇳 القوة الشبابية في الهند",

    indiaPoint1: "🌍 تمتلك الهند عددًا هائلًا من أفراد Gen Z و Gen Alpha.",
    indiaPoint2: "📱 منظومة تعتمد على الهاتف المحمول أولاً والذكاء الاصطناعي.",
    indiaPoint3: "🚀 مهيأة للتنفيذ وخلق الفرص.",

    alphaTitle: "⚡ جيل ألفا",
    alphaDesc:
      "جيل نشأ مع الذكاء الاصطناعي ويعيش في عالم رقمي بالكامل مع الأتمتة والألعاب والأنظمة الذكية.",

    genzTitle: "🚀 جيل Z",
    genzDesc:
      "جيل يقود اقتصاد المبدعين وعقلية الشركات الناشئة والقوى العاملة الرقمية.",

    whyTitle: "🧠 لماذا هذا مهم",
    whyDesc:
      "تم تصميمه لمساعدة Gen Z و Gen Alpha على تحويل التعلم إلى تنفيذ، والمهارات إلى فرص، والأفكار إلى نتائج واقعية."
  },

  ja: {
    title: "🌍 未来はGen ZとGen Alphaのもの",
    subtitle:
      "彼らは合わせて人類のほぼ半数を占め、AI時代を形作る世代です。",

    generation: "世代",
    birthYears: "生年",
    population: "人口",
    share: "割合",

    indiaSnapshot: "🇮🇳 インド世代の概要",
    indiaYouthAdvantage: "🇮🇳 インドの若者の強み",

    indiaPoint1: "🌍 インドにはGen ZとGen Alphaの大規模な人口があります。",
    indiaPoint2: "📱 モバイルファーストかつAIネイティブな環境。",
    indiaPoint3: "🚀 実行力と機会創出に向けて構築されています。",

    alphaTitle: "⚡ ジェネレーション・アルファ",
    alphaDesc:
      "AIネイティブで完全にデジタル中心の世代。自動化、ゲーム、インテリジェントシステムとともに成長しています。",

    genzTitle: "🚀 ジェネレーションZ",
    genzDesc:
      "クリエイターエコノミー、スタートアップ思考、デジタル人材を牽引する世代。",

    whyTitle: "🧠 なぜ重要なのか",
    whyDesc:
      "Gen ZとGen Alphaが学びを実践へ、スキルを機会へ、アイデアを現実の成果へと変えるために作られています。"
  },
  zh: {
    title: "🌍 未来属于 Gen Z 与 Gen Alpha",
    subtitle:
      "他们共同代表了近一半的人类，并将定义人工智能时代。",

    generation: "世代",
    birthYears: "出生年份",
    population: "人口",
    share: "占比",

    indiaSnapshot: "🇮🇳 印度世代概览",
    indiaYouthAdvantage: "🇮🇳 印度的青年优势",

    indiaPoint1: "🌍 印度拥有庞大的 Gen Z 和 Gen Alpha 人口。",
    indiaPoint2: "📱 以移动互联网为先、AI 原生的生态系统。",
    indiaPoint3: "🚀 为执行力和创造机会而打造。",

    alphaTitle: "⚡ Alpha 世代",
    alphaDesc:
      "AI 原生、完全数字优先的一代，在自动化、游戏和智能系统环境中成长。",

    genzTitle: "🚀 Z 世代",
    genzDesc:
      "创作者经济、创业思维以及数字化劳动力的领导者。",

    whyTitle: "🧠 为什么这很重要",
    whyDesc:
      "帮助 Gen Z 和 Gen Alpha 将学习转化为行动、将技能转化为机会、将想法转化为现实成果。"
  },

  ko: {
    title: "🌍 미래는 Gen Z와 Gen Alpha의 것입니다",
    subtitle:
      "이들은 함께 인류의 거의 절반을 차지하며 AI 시대를 이끌어 갈 세대입니다.",

    generation: "세대",
    birthYears: "출생 연도",
    population: "인구",
    share: "비율",

    indiaSnapshot: "🇮🇳 인도 세대 현황",
    indiaYouthAdvantage: "🇮🇳 인도의 청년 경쟁력",

    indiaPoint1: "🌍 인도에는 Gen Z와 Gen Alpha 인구가 매우 많습니다.",
    indiaPoint2: "📱 모바일 중심의 AI 네이티브 생태계.",
    indiaPoint3: "🚀 실행력과 기회 창출을 위해 설계되었습니다.",

    alphaTitle: "⚡ 알파 세대",
    alphaDesc:
      "AI 네이티브이자 완전한 디지털 중심 세대로, 자동화·게임·지능형 시스템과 함께 성장하고 있습니다.",

    genzTitle: "🚀 Z세대",
    genzDesc:
      "크리에이터 경제, 스타트업 정신, 디지털 인력을 이끄는 세대입니다.",

    whyTitle: "🧠 왜 중요한가",
    whyDesc:
      "Gen Z와 Gen Alpha가 학습을 실행으로, 기술을 기회로, 아이디어를 실제 성과로 전환할 수 있도록 설계되었습니다."
  },

  es: {
    title: "🌍 El futuro pertenece a la Generación Z y la Generación Alpha",
    subtitle:
      "Juntas representan casi la mitad de la humanidad y definirán la era de la IA.",

    generation: "Generación",
    birthYears: "Años de nacimiento",
    population: "Población",
    share: "Participación",

    indiaSnapshot: "🇮🇳 Panorama generacional de la India",
    indiaYouthAdvantage: "🇮🇳 La ventaja juvenil de la India",

    indiaPoint1: "🌍 India tiene una enorme población de Gen Z y Gen Alpha.",
    indiaPoint2: "📱 Ecosistema centrado en móviles y nativo en IA.",
    indiaPoint3: "🚀 Diseñado para la ejecución y la creación de oportunidades.",

    alphaTitle: "⚡ Generación Alpha",
    alphaDesc:
      "Generación nativa de IA y completamente digital que crece con la automatización, los videojuegos y los sistemas inteligentes.",

    genzTitle: "🚀 Generación Z",
    genzDesc:
      "Líderes de la economía de creadores, la mentalidad emprendedora y la fuerza laboral digital.",

    whyTitle: "🧠 Por qué esto importa",
    whyDesc:
      "Diseñado para que Gen Z y Gen Alpha transformen el aprendizaje en acción, las habilidades en oportunidades y las ideas en resultados reales."
  },

  pt: {
    title: "🌍 O futuro pertence à Geração Z e à Geração Alpha",
    subtitle:
      "Juntas, elas representam quase metade da humanidade e definirão a era da IA.",

    generation: "Geração",
    birthYears: "Anos de nascimento",
    population: "População",
    share: "Participação",

    indiaSnapshot: "🇮🇳 Panorama das gerações da Índia",
    indiaYouthAdvantage: "🇮🇳 A vantagem jovem da Índia",

    indiaPoint1: "🌍 A Índia possui uma enorme população de Gen Z e Gen Alpha.",
    indiaPoint2: "📱 Ecossistema mobile-first e nativo em IA.",
    indiaPoint3: "🚀 Construído para execução e criação de oportunidades.",

    alphaTitle: "⚡ Geração Alpha",
    alphaDesc:
      "Geração nativa em IA e totalmente digital, crescendo com automação, jogos e sistemas inteligentes.",

    genzTitle: "🚀 Geração Z",
    genzDesc:
      "Líderes da economia dos criadores, mentalidade empreendedora e força de trabalho digital.",

    whyTitle: "🧠 Por que isso importa",
    whyDesc:
      "Construído para que a Gen Z e a Gen Alpha transformem aprendizado em ação, habilidades em oportunidades e ideias em resultados reais."
  },
  fr: {
    title: "🌍 L’avenir appartient à la Génération Z et à la Génération Alpha",
    subtitle:
      "Ensemble, elles représentent près de la moitié de l’humanité et façonneront l’ère de l’IA.",

    generation: "Génération",
    birthYears: "Années de naissance",
    population: "Population",
    share: "Part",

    indiaSnapshot: "🇮🇳 Aperçu des générations en Inde",
    indiaYouthAdvantage: "🇮🇳 L’avantage de la jeunesse indienne",

    indiaPoint1: "🌍 L’Inde possède une immense population de Gen Z et Gen Alpha.",
    indiaPoint2: "📱 Un écosystème mobile-first et natif de l’IA.",
    indiaPoint3: "🚀 Conçu pour l’exécution et la création d’opportunités.",

    alphaTitle: "⚡ Génération Alpha",
    alphaDesc:
      "Une génération native de l’IA, entièrement numérique, qui grandit avec l’automatisation, les jeux vidéo et les systèmes intelligents.",

    genzTitle: "🚀 Génération Z",
    genzDesc:
      "Les leaders de l’économie des créateurs, de l’esprit entrepreneurial et de la main-d’œuvre numérique.",

    whyTitle: "🧠 Pourquoi c’est important",
    whyDesc:
      "Conçu pour aider la Gen Z et la Gen Alpha à transformer l’apprentissage en action, les compétences en opportunités et les idées en résultats concrets."
  },

  id: {
    title: "🌍 Masa Depan Milik Gen Z dan Gen Alpha",
    subtitle:
      "Bersama-sama mereka mewakili hampir setengah umat manusia dan akan menentukan era AI.",

    generation: "Generasi",
    birthYears: "Tahun Kelahiran",
    population: "Populasi",
    share: "Porsi",

    indiaSnapshot: "🇮🇳 Gambaran Generasi India",
    indiaYouthAdvantage: "🇮🇳 Keunggulan Generasi Muda India",

    indiaPoint1: "🌍 India memiliki populasi Gen Z dan Gen Alpha yang sangat besar.",
    indiaPoint2: "📱 Ekosistem mobile-first dan AI-native.",
    indiaPoint3: "🚀 Dibangun untuk eksekusi dan penciptaan peluang.",

    alphaTitle: "⚡ Generasi Alpha",
    alphaDesc:
      "Generasi AI-native yang sepenuhnya digital, tumbuh bersama otomatisasi, game, dan sistem cerdas.",

    genzTitle: "🚀 Generasi Z",
    genzDesc:
      "Pemimpin ekonomi kreator, pola pikir startup, dan tenaga kerja digital.",

    whyTitle: "🧠 Mengapa Ini Penting",
    whyDesc:
      "Dibangun untuk membantu Gen Z dan Gen Alpha mengubah pembelajaran menjadi tindakan, keterampilan menjadi peluang, dan ide menjadi hasil nyata."
  },

  ms: {
    title: "🌍 Masa Depan Milik Gen Z dan Gen Alpha",
    subtitle:
      "Bersama-sama mereka mewakili hampir separuh umat manusia dan akan membentuk era AI.",

    generation: "Generasi",
    birthYears: "Tahun Kelahiran",
    population: "Populasi",
    share: "Bahagian",

    indiaSnapshot: "🇮🇳 Gambaran Generasi India",
    indiaYouthAdvantage: "🇮🇳 Kelebihan Belia India",

    indiaPoint1: "🌍 India mempunyai populasi Gen Z dan Gen Alpha yang sangat besar.",
    indiaPoint2: "📱 Ekosistem mudah alih-utama dan AI-native.",
    indiaPoint3: "🚀 Dibina untuk pelaksanaan dan penciptaan peluang.",

    alphaTitle: "⚡ Generasi Alpha",
    alphaDesc:
      "Generasi AI-native yang sepenuhnya digital, membesar bersama automasi, permainan dan sistem pintar.",

    genzTitle: "🚀 Generasi Z",
    genzDesc:
      "Pemimpin ekonomi pencipta, pemikiran startup dan tenaga kerja digital.",

    whyTitle: "🧠 Mengapa Ini Penting",
    whyDesc:
      "Dibina untuk membantu Gen Z dan Gen Alpha menukar pembelajaran kepada tindakan, kemahiran kepada peluang dan idea kepada hasil dunia sebenar."
  },

  de: {
    title: "🌍 Die Zukunft gehört der Generation Z und Generation Alpha",
    subtitle:
      "Gemeinsam repräsentieren sie nahezu die Hälfte der Menschheit und werden das KI-Zeitalter prägen.",

    generation: "Generation",
    birthYears: "Geburtsjahre",
    population: "Bevölkerung",
    share: "Anteil",

    indiaSnapshot: "🇮🇳 Überblick über Indiens Generationen",
    indiaYouthAdvantage: "🇮🇳 Indiens Jugendvorteil",

    indiaPoint1: "🌍 Indien hat eine riesige Gen-Z- und Gen-Alpha-Bevölkerung.",
    indiaPoint2: "📱 Mobile-First- und KI-native-Ökosystem.",
    indiaPoint3: "🚀 Für Umsetzung und Chancenschaffung entwickelt.",

    alphaTitle: "⚡ Generation Alpha",
    alphaDesc:
      "Eine KI-native, vollständig digitale Generation, die mit Automatisierung, Gaming und intelligenten Systemen aufwächst.",

    genzTitle: "🚀 Generation Z",
    genzDesc:
      "Führend in der Creator Economy, Startup-Mentalität und digitalen Arbeitswelt.",

    whyTitle: "🧠 Warum das wichtig ist",
    whyDesc:
      "Entwickelt, um Gen Z und Gen Alpha dabei zu helfen, Lernen in Handeln, Fähigkeiten in Chancen und Ideen in reale Ergebnisse umzuwandeln."
  },

  tr: {
    title: "🌍 Gelecek Gen Z ve Gen Alpha'ya Ait",
    subtitle:
      "Birlikte insanlığın neredeyse yarısını temsil ediyorlar ve yapay zeka çağını şekillendirecekler.",

    generation: "Nesil",
    birthYears: "Doğum Yılları",
    population: "Nüfus",
    share: "Pay",

    indiaSnapshot: "🇮🇳 Hindistan Nesil Görünümü",
    indiaYouthAdvantage: "🇮🇳 Hindistan'ın Gençlik Avantajı",

    indiaPoint1: "🌍 Hindistan, çok büyük bir Gen Z ve Gen Alpha nüfusuna sahiptir.",
    indiaPoint2: "📱 Mobil öncelikli ve yapay zeka yerel ekosistemi.",
    indiaPoint3: "🚀 Uygulama ve fırsat yaratımı için tasarlanmıştır.",

    alphaTitle: "⚡ Alfa Kuşağı",
    alphaDesc:
      "Otomasyon, oyunlar ve akıllı sistemlerle büyüyen, yapay zeka yerli ve tamamen dijital bir nesil.",

    genzTitle: "🚀 Z Kuşağı",
    genzDesc:
      "İçerik üretici ekonomisinin, girişimci zihniyetin ve dijital iş gücünün liderleri.",

    whyTitle: "🧠 Bu Neden Önemli",
    whyDesc:
      "Gen Z ve Gen Alpha'nın öğrenmeyi eyleme, becerileri fırsatlara ve fikirleri gerçek dünya sonuçlarına dönüştürmesine yardımcı olmak için oluşturulmuştur."
  }
};